import { Supplier } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";

export class WholesalerEndpoint extends BaseEndpoint("wholesalers") {
  getAll(): Promise<Supplier[]> {
    return this.request();
  }
}
